import styled from 'styled-components';

const StyledFilterTabs = styled.div`
  button {
    padding: ${(props) => props.padding ?? '8px'};
    background-color: ${({ theme }) =>
      theme?.dark ? theme.tableHeaderBg : theme.white};
    border: ${({ theme, props }) =>
      theme?.dark
        ? `1.5px solid ${theme.inputBorder}`
        : `1.5px solid ${theme.borderLight}`};
    display: flex;
    align-items: center;
    &:active,
    &:focus,
    &.active {
      color: ${({ theme }) =>
        theme?.dark ? theme?.primaryText : theme.darkText};
      border: ${({ theme, props }) =>
        theme?.dark
          ? `1.5px solid ${theme.primaryDark}`
          : `1.5px solid ${theme.secondary}`};
      background-color: ${({ theme }) =>
        theme?.dark ? theme?.filterHoverBg : theme.secondaryLight2};
    }
    &:hover {
      // color: ${({ theme }) => theme.secondary};
      border: ${({ theme, props }) =>
        theme?.dark
          ? `1.5px solid ${theme.primaryDark}`
          : `1.5px solid ${theme.secondaryLight}`};
      background-color: ${({ theme }) =>
        theme?.dark ? theme?.filterHoverBg : theme.secondaryLight} !important;
    }
    &.not-active {
      background-color: ${({ theme }) =>
        theme?.dark ? theme.tableHeaderBg : theme.white};
      border: ${({ theme, props }) =>
        theme?.dark
          ? `1.5px solid ${theme.inputBorder}`
          : `1.5px solid ${theme.inputBorder}`};
    }
  }
`;

export default StyledFilterTabs;
